import { createTheme } from '@mui/material'
import type { ThemeOptions } from '@mui/material'
import { merge } from 'lodash-es'
import baseTheme from '@hypotenuse/platform/src/utils/Theme'
import { PRIMARY_COLOR_OVERRIDE } from './Colors'

/**
 * MUI theme options specific to the article preview page
 */
const themeOverrideOptions: ThemeOptions = {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    }
  },
  shape: {
    borderRadius: 16
  },
  palette: {
    primary: {
      main: PRIMARY_COLOR_OVERRIDE
    }
  }
}

// Merge the theme overrides into the base Phoenix theme
const themeOverride = createTheme(merge({}, baseTheme, themeOverrideOptions))
export default themeOverride
